import { Component, OnInit , NgZone} from '@angular/core';
import { NgForm } from '@angular/forms';
import {Response, Http} from '@angular/http';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CartService } from '../../services/cart.service';
import { CommonService } from '../../services/common.service';
import { Shipping } from '../../classes/shipping';
import {Billing} from '../../classes/billing';
import { MatDialog, MatDialogRef } from '@angular/material';
import { MapComponent } from '../../usersettings/map/map.component';
import { GoogleMapsAPIWrapper } from '@agm/core';
import { MapsAPILoader } from '@agm/core';
import { MatSnackBar } from '@angular/material';
declare var google: any;
@Component({
  selector: 'app-editaddress',
  templateUrl: './editaddress.component.html',
  styleUrls: ['./editaddress.component.css']
})
export class EditaddressComponent implements OnInit {
  changeneed: any;
  edid: any;
  rflag: any;
  request: { latLng: any; };
  geocoder: any;
  adtitle: any;
  userid: any;
  username: any;
  isdefault = 0;
  address: any ;
  msg: any;
  gdata: any;
   gjson: any;
   uemail: any;
   umobile: any;
   lat: any;
   lon: any;
   addl1: any;
   addl2: any;
   cityid: any;
   stateid: any;
   countryid: any;
   phone: any;
   pin: any;
   action: any;
   msg1: any;
   loading = false;
  constructor(private cartService: CartService, private router: Router, private commonService: CommonService,
    private route: ActivatedRoute, public dialog: MatDialog, public mapsApiLoader: MapsAPILoader,
    private zone: NgZone,  private snackbar: MatSnackBar) {
      const udata = this.commonService.getUserDataLocally();
      this.userid = udata.uid;
      this.username = udata .uname;
      this.uemail = udata.uemail;
      this.adtitle = this.route.snapshot.params['type'];
      this.rflag = this.route.snapshot.params['flag'];
      this.edid = this.route.snapshot.params['id'];
     }

  ngOnInit() {
    if (this.adtitle === 'shipping') {
      this.getShippingAddress()
    }
    if (this.adtitle === 'billing') {
      this.getBillingAddress()
    }
  }
  getShippingAddress() {
    this.loading = true;
    this.cartService.getShippingAddress(this.edid)
    .subscribe(
      (x) => {
        this.address = x;
        this.addl1 = this.address[0].add_l1;
        this.addl2 = this.address[0].add_l2;
        this.cityid = this.address[0].city_id;
        this.countryid = this.address[0].country_id;
        this.stateid = this.address[0].state_id;
        this.pin = this.address[0].pin;
        this.phone = this.address[0].phone;
        this.lat = this.address[0].lat;
        this.lon = this.address[0].lon;
        this.loading = false ;
      }
    );
  }
  getBillingAddress() {
    this.cartService.getBillingAddress(this.edid)
    .subscribe(
      (x) => {
        this.address = x;
        this.addl1 = this.address[0].add_l1;
        this.addl2 = this.address[0].add_l2;
        this.cityid = this.address[0].city_id;
        this.countryid = this.address[0].country_id;
        this.stateid = this.address[0].state_id;
        this.pin = this.address[0].pin;
        this.phone = this.address[0].phone;
        this.lat = this.address[0].lat;
        this.lon = this.address[0].lon;
        this.loading = false ;
      }
    );
  }
  checkUpdateNeeded() {
    this.changeneed = true;
    if ( this.addl1 === this.address[0].add_l1 && this.addl2 === this.address[0].add_l2 &&
      this.cityid === this.address[0].city_id && this.countryid === this.address[0].country_id &&
      this.stateid === this.address[0].state_id && this.pin === this.address[0].pin &&
      this.phone === this.address[0].phone && this.lat === this.address[0].lat &&
      this.lon === this.address[0].lon) {
        this.changeneed = false;
      }
      if (this.changeneed) {
        this.updateAddress();
      }else {
        this.msg1 = 'No Change In Address';
        this.openSnackBar();
        this.cancel();
      }
  }
  updateAddress() {
    if (this.adtitle === 'shipping') {
      this.editUserShippingAddress();
    }
    if (this.adtitle === 'billing') {
      this.editUserBillingAddress();
    }
  }
  editUserShippingAddress() {
    this.loading = true;
    this.commonService.updateShipAdd(this.edid , this.addl1, this.addl2, this.cityid,
      this.stateid, this.countryid, this.pin, this.phone, this.lat, this.lon)
     .subscribe(
        (x) => {
          this.loading = false;
          this.msg1 = 'Address Successfully updated';
          this.openSnackBar();
          this.cancel();
        });
  }
  editUserBillingAddress() {
    this.loading = true;
    this.commonService.updateBillAdd(this.edid , this.addl1, this.addl2, this.cityid,
      this.stateid, this.countryid, this.pin, this.phone, this.lat, this.lon)
     .subscribe( 
        (x) => {
          this.loading = false;
          this.msg1 = 'Address Successfully updated';
          this.openSnackBar();
          this.cancel();
        });
  }
  public getLocation() {
    this.loading = true;
   if (window.navigator.geolocation) {
    window.navigator.geolocation.getCurrentPosition(
      (pos) => this.setPosition(pos));
   } else {
     this.loading = false;
       console.log('Geolocation is not supported by this browser') ;
   }
 }
 public  setPosition(position) {
  this.lat  = position.coords.latitude ;
  this. lon =  position.coords.longitude;
  this.loading = false;
  this.openMap();
  }
 public openMap() {
   const dialogRef = this.dialog.open(MapComponent, {
     width: '700px',
     height: '700px',
     data: {lat: this.lat, lon: this.lon}
   });
   dialogRef.afterClosed().subscribe(result => {
     if (result !== undefined) {
      this.lon = result.lon;
      this.lat = result.lat;
      this.translateMylocation();
     }
   });
 }
 translateMylocation() {
   this.mapsApiLoader.load().then(() => {
     this.loading = true;
     this.geocoder = new google.maps.Geocoder();
     const latlng = new google.maps.LatLng(this.lat, this.lon);
     this.request = {
       latLng: latlng
     };
     this.convertLocation();
   });
  }
  convertLocation() {
   this.loading = false;
     this.geocoder.geocode(this.request, (results, status) => {
     
       if (status === google.maps.GeocoderStatus.OK) {
                   if (results[0] != null) {
                     const len = results[0].address_components.length;
                     this.zone.run(() => {
                       this.addl1 = results[0].address_components[results[0].address_components.length - len].short_name
                       + ',' + results[0].address_components[results[0].address_components.length - len + 1].short_name; 
              this.addl2 =  results[0].address_components[results[0].address_components.length - len + 2].short_name;
              if ( results[0].address_components[results[0].address_components.length - 5].short_name === 'Bengaluru') {
                this.cityid = 1;
              }
              if ( results[0].address_components[results[0].address_components.length - 3].short_name == 'KA') {
               this.stateid = 1;
             }
           if ( results[0].address_components[results[0].address_components.length - 2].short_name == 'IN') {
               this.countryid = 1;
             }
             if ( results[0].address_components[results[0].address_components.length - 5].short_name !== 'Bengaluru') {
            alert('Our services are unavailable in your selected area.');
            }
            this.pin = results[0].address_components[len - 1].short_name;
                   });
                 } else {
                               alert('No address available');
                               this.loading = false;
                             }
                  }
       });
  }
  openSnackBar() {
   this.snackbar.open(this.msg1 , this.action, {
     duration: 4000,
   });
 }
 cancel() {
   if (this.rflag == 'checkout') {
     this.router.navigate(['/store/checkout']);
    }
    if (this.rflag == 'manageprofile') {
     this.router.navigate(['/manageprofile/useraddress/manageprofile']);
    }
 }
}
